import React, { useEffect } from 'react';

import { useHistory, useParams } from "react-router-dom";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import UserAvatar from '../UserAvatar';
import UserDetailForm from './UserDetailForm';
import UserBioForm from './UserBioForm';
import UserNotesForm from './UserNotesForm';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    tabs: {
        borderBottom: '1px solid #ddd',
    },
    userPictureWrapper: {
        width: 450,
        maxWidth: '100%',
        '& > div': {
            width: '100%'
        }
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box py={1}>{children}</Box>
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const SampleCouples = props => {
    const { user } = props;
    const classes = useStyles();

    const renderWeddings = () => {
        return (
            <div>
                {user.weddings.map(wedding => {
                    return (
                        <p key={`wedding-${wedding.id}`} className='mb-0' style={{ fontSize: '90%' }}>
                            <span><a href={`/admin/couples/${wedding.id}`} target="_blank">
                                {wedding.bride_full_name} & {wedding.groom_full_name}
                            </a></span>
                            <span> - {wedding.wedding_date_formatted}</span>
                        </p>
                    )
                })}
            </div>
        )
    }

    return (
        <div>
            <h5>Sample Couples</h5>
            {user.weddings.length > 0 && renderWeddings()}
            {user.weddings.length < 1 && <p>No sample couples for this user</p>}
        </div>
    )
}

const ProfileTab = props => {
    const { user, setUser } = props;
    const classes = useStyles();

    return (
        <React.Fragment>
            {user === null && (
                <Box my={3}>
                    <CircularProgress />
                </Box>
            )}
            {user !== null && (
                <React.Fragment>
                    <Box mb={4} className={classes.userPictureWrapper}>
                        <UserAvatar user={user} setUser={setUser} />
                    </Box>
                    <Grid container>
                        <Grid item xs={12} sm={7} md={6}>
                            <UserDetailForm user={user} />
                        </Grid>
                        <Grid item xs={12} sm={5} md={6} className='pl-sm-4'>
                            <SampleCouples user={user} />
                        </Grid>
                    </Grid>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

const BioTab = props => {
    const { user } = props;

    return (
        <React.Fragment>
            {user === null && (
                <Box my={3}>
                    <CircularProgress />
                </Box>
            )}
            {user !== null && (
                <React.Fragment>
                    <UserBioForm user={user} />
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

const NotesTab = props => {
    const { user } = props;

    return (
        <React.Fragment>
            {user === null && (
                <Box my={3}>
                    <CircularProgress />
                </Box>
            )}
            {user !== null && (
                <React.Fragment>
                    <UserNotesForm user={user} />
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

const UserDetail = () => {
    const { id } = useParams();

    const [user, setUser] = React.useState(null);

    const classes = useStyles();

    const history = useHistory();
    function handleBackClick() {
        history.push('/admin/users');
    }

    const defaultOfficiantInfo = {
        location: '',
        profile_link: '',
    };

    useEffect(() => {
        document.title = 'Edit User - Enduring Promises';

        new Promise((resolve, reject) => {
            let url = `/api/admin/users/${id}`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    result.officiant_info = result.officiant_info ? result.officiant_info : defaultOfficiantInfo;
                    setUser(result);
                    document.title = `Edit ${result.name} - Enduring Promises`;
                    resolve();
                })
        });
    }, [id]);

    /* state for tabs */
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <Box mb={2}>
                <Button startIcon={<Icon>chevron_left</Icon>} size="small" onClick={handleBackClick} variant="outlined" color="primary">Back</Button>
            </Box>
            <Paper square>
                <Box className={classes.root}>
                    <Box>
                        <Typography>User Profile {user !== null ? `- ${user.name}` : ''}</Typography>
                    </Box>
                    <Box mt={3}>
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" className={classes.tabs}>
                            <Tab label="Profile" {...a11yProps(0)} />
                            <Tab label="Bio" {...a11yProps(1)} />
                            <Tab label="Notes" {...a11yProps(2)} />
                        </Tabs>
                        <TabPanel value={value} index={0}>
                            <ProfileTab user={user} setUser={setUser} />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <BioTab user={user} />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <NotesTab user={user} />
                        </TabPanel>
                    </Box>
                </Box>
            </Paper>
        </div>
    );
}

export default UserDetail;
